document.addEventListener('cart:refresh', function() {
  if (window._kwCartAdding) return;
});

window._kwOpenCartAfterReload = function() {
  var btn = document.querySelector('button[aria-label="Sepet"], button[aria-label="Cart"]');
  if (btn) btn.click();
};

// Sayfa yüklendikten sonra sepeti aç
if (sessionStorage.getItem('kw_open_cart')) {
  sessionStorage.removeItem('kw_open_cart');
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      var btn = document.querySelector('button[aria-label="Sepet"], button[aria-label="Cart"]');
      if (btn) btn.click();
    }, 800);
  });
}